import { CompanyAPI } from '@api';

const defaultOptions = { rowsPerPage: 40, currentPage: 1, search: '' };

const getCreditOperations = async (options = {}) => {
  const { rowsPerPage, currentPage, search } = { ...defaultOptions, ...options };
  const params = { rows_per_page: rowsPerPage, current_page: currentPage, filter_str: search };

  return CompanyAPI.getCreditOperations(params)
    .then(({ data }) => data)
    .catch((error) => Promise.reject(error.response));
};

export { getCreditOperations };
